import {React} from '@api'
import {SpecCardPdf, usePdfStore, Watermark} from '@modules/pdf'
import {Page, View,} from '@react-pdf/renderer';
import {styled} from '@pdf'
import {PdfPageProps} from '@stores'

const ReportPageStyled = styled.Page`
  padding:20px 36px;
  display:flex;
  flex-direction: column;
`

const PageTitleBar = styled.View`
border-top-width: 4mm;
border-top-style:solid;
border-top-color: #bec3ce;
display:flex;
flex-direction: row;
margin-bottom:6mm;
padding-top:2mm;
flex-shrink: 0;
flex-grow:0;
min-height:15mm;
width:100%;
`

// Text-align wasn't working in flex-box
const PageTitle = styled.Text`
text-align: center;
//flex-grow:1;
position:absolute;
width:100%;
top: 5mm;
`

const WatermarkContainer = styled.View`
  position:absolute;
  width:100%;
  bottom: 10mm;
  left:15mm;
 /*position:absolute;
 bottom:15px;
 left:30px;
 width:calc(100% - 30px);*/
`

export const ReportPage : React.FunctionComponent<PdfPageProps & any> = ({children, hideTitle, summaryTitle, summarySubtitle, pageTitle, item, itemType, ...props}) => {
  const pdf = usePdfStore()

  return <ReportPageStyled wrap={false} {...props}>
    {!hideTitle && <PageTitleBar>
      <PageSummaryInfo title={summaryTitle}
                       subtitle={summarySubtitle} item={item} itemType={itemType}/>
      <PageTitle>{pageTitle}</PageTitle>
    </PageTitleBar>}

    <View style={{flexGrow:1, flexShrink:1, display:'flex', flexDirection: 'column'}}>
      {children}
    </View>

    {pdf.config.watermark &&
    <WatermarkContainer>
      <Watermark/>
    </WatermarkContainer>}
  </ReportPageStyled>

}

const SummaryInfoView = styled.View`
  font-size:14px;
  display:flex;
  flex-direction: row;
  flex-grow:0;
  width:5cm;
  height:1cm;
`

const SummaryInfoCol1 = styled.View`
  flex-grow:0;
  margin-right:4mm;
`

const SummaryInfoCol2  = styled.View`
  font-size:12px;
  display:flex;
  flex-direction: column;  
  flex-grow:0;
`
const SummaryInfoTitle = styled.Text`
  margin: auto 0;
  font-size:12px;
`

const SummaryInfoSubtitle = styled.Text`
  margin: auto 0;
  font-size:12px;
`

export const PageSummaryInfo: React.FunctionComponent<{ title: string, subtitle?: string, style?, item?, itemType? }> = ({title, subtitle, style, item, itemType}) => {
  return <SummaryInfoView style={style}>
    {item &&
  <SummaryInfoCol1>
    <SpecCardPdf showTitle={false} spec={item} style={{padding: 0}}/>
  </SummaryInfoCol1>}

    <SummaryInfoCol2>
      {!_.isEmpty(title) && <SummaryInfoTitle>{title}</SummaryInfoTitle>}
      {!_.isEmpty(subtitle) && <SummaryInfoSubtitle>{subtitle}</SummaryInfoSubtitle>}
    </SummaryInfoCol2>
  </SummaryInfoView>
}



// WEBPACK FOOTER //
// ./src/modules/pdf/templates/ReportPage.tsx